import type { EntityRef, EntityRouteResolver } from '@ruta/shared';

/**
 * Resolve a canonical EntityRef to a webapp route string.
 */
export const resolveEntityRoute: EntityRouteResolver = (ref: EntityRef): string | null => {
  switch (ref.type) {
    case 'CUSTOMER':
      return `/customers/${ref.params.id}`;
    case 'VISIT':
      // A visit lives on its customer's page. Defer to the canonical
      // /visits/:id route, which resolves the owning customer and redirects
      // there with the visit selected (see EntityPathRedirect).
      return `/visits/${ref.params.id}`;
    case 'SUBSCRIPTION':
      return `/customers/${ref.params.customerId}?tab=services&subscriptionId=${ref.params.subscriptionId}`;
    case 'SERVICE_TEMPLATE':
      return `/service-templates/${ref.params.id}`;
    case 'INVOICE':
      return `/invoices/${ref.params.id}`;
    case 'CREW':
      return `/map?view=crews&crewId=${ref.params.id}`;
    case 'CHAT_CONVERSATION':
      return `/assistant`;
    case 'ORGANIZATION_MEMBER':
      return `/team?memberId=${ref.params.id}`;
    case 'RATE_REQUEST':
      return `/rate-requests/${ref.params.id}`;
    case 'MESSAGE':
      return `/messages?messageId=${ref.params.id}`;
    default:
      return null;
  }
};
